exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deposit[data-v-42962c1a]{margin-bottom:15px}.deposit__desc--error[data-v-42962c1a]{color:var(--red);background:var(--light-red);padding:5px;border-radius:5px}.deposit .input.account__section__input>input[data-v-42962c1a]{background:var(--white);border-radius:4px}", ""]);

// exports
